import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { useMemo } from 'react';
interface Props {
  isStocked: boolean;
  setIsStocked: (isStocked: boolean) => void;
}

export function StockedStatusToggleGroup({ isStocked, setIsStocked }: Props) {
  const t = useMyAssortmentTFunction();

  const stockedOptions: ToggleGroupOption<'L' | 'B'>[] = useMemo(
    () => [
      { label: t('myAssortment.stockStatus.inStock'), value: 'L' },
      { label: t('myAssortment.stockStatus.order'), value: 'B' },
    ],
    [t]
  );
  return (
    <ToggleGroup
      label={t('myAssortment.stockStatus.status')}
      labelVariant="body1"
      labelDirection="vertical"
      size="small"
      fullWidth
      options={stockedOptions}
      value={isStocked ? 'L' : 'B'}
      onChange={(stockedStatus) =>
        stockedStatus === 'L' ? setIsStocked(true) : setIsStocked(false)
      }
    />
  );
}
